export const isNotFoundSpaceError = (error: any): any => error?.message?.includes('Cannot find space');
